module.exports = __webpack_public_path__ + "static/media/7.faba9d4b.jpg";